// CSS
import './datacenterWrapper.scss';
// JS Imports
import mori from 'mori';
import template from './datacenterWrapper.html';
import renderData from '../../services/renderData';
import stateGo from 'redux-ui-router/lib/state-go';
import {
  cleanCSV,
  downloader,
  processCellCallback,
  escapeNewLines,
  escapeCSVQuotes,
} from '../../services/processTableDataForDownload';
import { appDefault } from '../../config/config';

export default function() {
  return {
    scope: {},
    templateUrl: template,
    controller: mainController,
    controllerAs: 'dc',
  };
}

mainController.$inject = [
  '$scope',
  '$ngRedux',
  '$window',
  '$location',
  '$timeout',
  '$interval',
  'datacenterSheet',
];
function mainController(
  $scope,
  $ngRedux,
  $window,
  $location,
  $timeout,
  $interval,
  datacenterSheet
) {
  const disconnect = $ngRedux.connect((state) => {
    return {
      router: state.router,
      sheet: state.data,
      globalRules: state.data.globalRules,
      globalSettings: state.data.globalSettings,
      distributionCount: state.data.distributionCount,
    };
  })(this);

  $scope.$on('$destroy', disconnect);

  this.data = {};
  this.title = $window.document.title;

  // bootstrap the data
  $ngRedux.dispatch(datacenterSheet.buildSheetData());

  // For renderData... so we can access that state
  const reduxCallback = function(payload) {
    $ngRedux.dispatch(stateGo('datacenter.main', payload));
  };

  // update view when url changes
  $scope.$on('$locationChangeStart', (event, newval, oldval) => {
    this.bypassLocationChangeEvent =
      newval.replace(oldval, '').indexOf('#note') > -1;
  });

  $scope.$on('$locationChangeSuccess', () => {
    if (this.bypassLocationChangeEvent) {
      this.bypassLocationChangeEvent = false;
      this.highlightFootnote();
      return;
    }

    this.clearNoteHighlight();

    // If there are no keys, or only selectedRows (inter-indicator linking),
    // go back a page in the browser's history
    if (Object.keys($location.search())
      .filter((x) => x !== 'selectedRows').length === 0) {
      window.history.back();
      return;
    }
    if (Object.keys(this.data).length > 0) {
      renderData(
        this.sheet,
        this.data,
        this.router.currentParams,
        reduxCallback
      );
    }
  });

  // render after initial data load
  const initialWatch = $scope.$watch(
    () => this.sheet.immutableData,
    (newval) => {
      if (newval === undefined) {
        return;
      }

      renderData(
        this.sheet,
        this.data,
        this.router.currentParams,
        reduxCallback
      );

      const slugify = angular
        .injector(['ng', 'slugifier'])
        .get('slugifyFilter');

      if (this.router.currentParams.state) {
        const stateSlug = slugify(appDefault.stateLookup[
          this.router.currentParams.state.toUpperCase()
        ]);
        $ngRedux.dispatch(stateGo('datacenter.main', {
          selectedRows: {
            'states': {
              [stateSlug]: {},
            },
          },
          state: undefined,
        }));
      }

      // stop watching
      initialWatch();
    }
  );

  this.clearNoteHighlight = function() {
    Array.prototype.forEach.call(
      document.querySelectorAll('#footnote-holder li p'), (el) =>
      el.classList.remove('note-hilight')
    );
  };

  this.highlightFootnote = function() {
    this.clearNoteHighlight();

    if (!!$location.hash()) {
      $timeout(() => {
        $window.scrollTo(
          $window.scrollX,
          $window.scrollY -
            document.querySelector('header').clientHeight -
            ((document.getElementById('wpadminbar') || {}).clientHeight || 0)
        );
        this.cachedScrollY = $window.scrollY;
      });

      document.querySelector(`#${$location.hash()} p`)
        .classList.add('note-hilight');
    }
  };

  this.notesButtonClick = function() {
    this.bypassLocationChangeEvent = true;
    if (this.cachedScrollY) {
      $window.scrollTo(
        $window.scrollX,
        this.cachedScrollY
      );
    }
  };

  // Export data as csv, for options
  // see: https://www.ag-grid.com/angular-grid-export/
  //
  // @TODO this entire thing needs to be refactored
  // (also just move it to it's own file)
  this.downloadData = function() {
    /* eslint-disable no-alert */

    // @TODO: Refactor this to a service
    // Get footnotes, sources, notes, etc for the timeframe
    const notes = mori.intoArray(this.data.notes).reduce(
      (prev, curr) =>
        prev + `"${curr.name}"\n${curr.val.reduce(
          (prev1, curr1) => prev1 + `"${escapeCSVQuotes(curr1.Note)
            .split('\n').join('"\n"')}"\n`,
          ''
        )}\n`,
      '\n'
    );

    let footnotes = [];
    if (mori.count(this.data.footnotes) > 0) {
      footnotes = mori.intoArray(this.data.footnotes)
        .sort(({ label: aLabel }, { label: bLabel }) => aLabel - bLabel)
        .map(({ label, note }) => ({
          label,
          note: `${escapeNewLines(escapeCSVQuotes(note))}`,
        }))
        .reduce(
          (prev, { label, note }) =>
            `${prev}"${label}. ${note}"\n`,
          'Footnotes\n'
        );
    }

    const timeframes = (this.router.currentParams.activeTab === 'graph') ?
      [
        `${this.sheet.timeframes[this.router.currentParams.startTimeframe]}`,
        `${this.sheet.timeframes[this.router.currentParams.currentTimeframe]}`,
      ].join(' - ') :
      `${this.sheet.timeframes[this.router.currentParams.currentTimeframe]}`;

    const customHeader = [
      `"Title: ${document.title}"`,
      `"Timeframe: ${timeframes}"`,
      '', // Empty string so we get a newline at EOL
    ].join('\n');

    const headers = mori.filter(
      (item) => mori.get(item, 'type') === 'Location' ||
        mori.get(item, 'type') === mori.get(
          this.sheet.immutableDataviews,
          this.router.currentParams.dataView || 0,
        ).type
      , this.sheet.immutableHeaders
    );

    const customFooter = [
      notes,
      footnotes,
    ].join('\n');

    const dataAsCsv = this.data.table.api.getDataAsCsv({
      customFooter,
      customHeader,
      processCellCallback: processCellCallback(headers),
      processHeaderCallback: ({ column }) => column.colId,
    });

    downloader(
      'raw_data.csv',
      // No need to clean CSV if we have no footnotes!
      (footnotes.length > 0) ? cleanCSV(dataAsCsv) : dataAsCsv
    );
  };

  this.printWindow = function() {
    $window.open(
      [
        $location.absUrl().split('?')[0],
        'view/print/?print=true&',
        $location.url().split('?')[1],
      ].join(''),
      `Print Window | ${this.title}`,
      'toolbar=no, menubar=no, resizable=yes, location=no, scrollbars=yes'
    );
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/datacenterWrapper/index.js
 **/